import { useState } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Formik, FormikProps } from 'formik'
import { object, string } from 'yup'
import { isFuture } from 'date-fns'

import { Modal, useMessage } from '@pepper/ui'
import { updateCompanyDetails } from '@pepper/utils/src/api/PepperOrganization/updateCompanyDetails'

import { SelectField, DatePickerField } from 'components/FormFields/FormFields'
import { PEPPER_ENTITIES } from 'utils/constants/organizations'

import styles from './PepperOrganization.module.css'

type Props = {
  companyId: string
  refetchCompanyDetails: () => void
}

type FormValues = {
  onboarded_on: string
  pepperOrganization: string
}

const formInitialValues = {
  pepperOrganization: '',
  onboarded_on: '',
}

const PepperOrganization = NiceModal.create<Props>(
  ({ companyId, refetchCompanyDetails }) => {
    const { visible: isModalVisible, remove: removeModal } = useModal()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const { showSuccess, showError } = useMessage()

    const handleSubmit = async (values: FormValues) => {
      const { onboarded_on, pepperOrganization } = values

      setIsSubmitting(true)
      const response = await updateCompanyDetails({
        pepperOrganization,
        onboardedOn: onboarded_on,
        companyId,
      })
      setIsSubmitting(false)
      if (response.status === 'ok') {
        showSuccess('Organization Updated')
        refetchCompanyDetails()
      } else {
        showError(response.error)
      }
      removeModal()
    }

    return (
      <Formik
        initialValues={formInitialValues}
        onSubmit={handleSubmit}
        validationSchema={object({
          pepperOrganization: string().required(
            'Please select any one organization.'
          ),
          onboarded_on: string()
            .trim()
            .required('Please enter Onboarded On date.'),
        })}
        enableReinitialize={true}
      >
        {(formikProps: FormikProps<FormValues>): JSX.Element => {
          return (
            <Modal
              title="Select Pepper Organization"
              visible={isModalVisible}
              closable={true}
              centered={true}
              onOk={formikProps.submitForm}
              okButtonProps={{
                disabled: isSubmitting,
              }}
              onCancel={() => {
                removeModal()
              }}
              okText="Submit"
            >
              <div className={styles.formSection}>
                <SelectField
                  name="pepperOrganization"
                  label="Pepper Organization"
                  setFieldValue={formikProps.setFieldValue}
                  setFieldTouched={formikProps.setFieldTouched}
                  required={true}
                  fieldProps={{
                    options: PEPPER_ENTITIES,
                  }}
                />
                <DatePickerField
                  name="onboarded_on"
                  label="Onboarded On"
                  required={true}
                  fieldProps={{
                    disabledDate: current => {
                      return current && isFuture(current)
                    },
                    className: styles.datePicker,
                  }}
                />
              </div>
            </Modal>
          )
        }}
      </Formik>
    )
  }
)

export default PepperOrganization
